import { FutureLayerMeta, FutureLayerSlug } from 'components/features/future/types'

export const CHART_DESKTOP_STEPS = 10
export const CHART_MOBILE_STEPS = 30

export const LAYER_NAME_MAX_LENGTH = 40

export const RETIRE_AGE = 67

export const LAYER_METAS: Record<FutureLayerSlug, FutureLayerMeta> = {
  // Goals
  buy_home: {
    name: 'Buy Home',
    type: 'goal',
    icon: 'house',
  },
  vacation: {
    name: 'Vacation',
    type: 'goal',
    icon: 'travel-solid',
  },
  buy_car: {
    name: 'Buy Car',
    type: 'goal',
    icon: 'misc-car',
  },
  large_purchase: {
    name: 'Large Purchase',
    type: 'goal',
    icon: 'diamond',
  },
  get_married: {
    name: 'Get Married',
    type: 'goal',
    icon: 'heart',
  },
  have_child: {
    name: 'Have a Child',
    type: 'goal',
    icon: 'child',
  },
  get_degree: {
    name: 'Get a Degree',
    type: 'goal',
    icon: 'education-solid',
  },
  retirement: {
    name: 'Retire',
    type: 'goal',
    icon: 'palms',
  },

  // Events
  lose_job: {
    name: 'Lose Your Job',
    type: 'event',
    icon: 'income_loss',
  },
  sell_home: {
    name: 'Sell Home',
    type: 'event',
    icon: 'sell-house',
  },
  recession: {
    name: 'Recession',
    type: 'event',
    icon: 'trend_down',
  },
  income_change: {
    name: 'Income Change',
    type: 'event',
    icon: 'income_change',
  },
  sell_car: {
    name: 'Sell Car',
    type: 'event',
    icon: 'sell-car',
  },
  inherit_money: {
    name: 'Inherit Money',
    type: 'event',
    icon: 'inheritance',
  },
  new_expense: {
    name: 'New Expense',
    type: 'event',
    icon: 'health_medical',
  },
  get_divorced: {
    name: 'Get Divorced',
    type: 'event',
    icon: 'heart-broken',
  },
}
